import { API_HOST, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/registration`;

const getCreateInitialSocialPersonEndpoint = () => `${getEndpoint()}/social/initial`;
export const getCreateInitialSocialPersonRequest = (initialPerson) => [
  getCreateInitialSocialPersonEndpoint(),
  getHttpPostOptions(initialPerson),
];

const getCreateInitialPersonEndpoint = () => `${getEndpoint()}/initial`;
export const getCreateInitialPersonRequest = (initialPerson) => [
  getCreateInitialPersonEndpoint(),
  getHttpPostOptions(initialPerson),
];

const getRegisterEndpoint = () => `${getEndpoint()}/register`;
export const getRegisterRequest = (registration) => [getRegisterEndpoint(), getHttpPostOptions(registration)];

const getKeycloakRegistrationEndpoint = () => `${getEndpoint()}/create/keycloak-user`;
export const getKeycloakRegistrationRequest = (keycloakRegistration) => [
  getKeycloakRegistrationEndpoint(),
  getHttpPostOptions(keycloakRegistration),
];
